// 현장 사진 모델. 백엔드 entity.SitePhoto 와 1:1 매칭.
import type { CreatedByFields } from './CreatedBy';

export const PHOTO_CATEGORIES = ['rack', 'exterior', 'cable', 'incident', 'other'] as const;
export type PhotoCategory = typeof PHOTO_CATEGORIES[number] | string;

export const PHOTO_CATEGORY_LABEL: Record<string, string> = {
  rack: '랙',
  exterior: '외관 / 전경',
  cable: '케이블',
  incident: '장애 현장',
  other: '기타',
};

export interface SitePhoto extends CreatedByFields {
  id: number;
  site_project_id: number;
  filename: string;
  original_name: string;
  mime_type?: string;
  size_bytes?: number;
  category: string;
  taken_at?: string | null;
  uploaded_by?: string;
  note?: string;
  related_incident_id?: number | null;
  related_visit_log_id?: number | null;
  created_at: string;
  updated_at: string;
}

/**
 * 동영상 항목 여부 — 보관함(SitePhoto)은 사진과 동영상을 함께 담는다.
 * `<img>` 로 그리면 엑박이 되므로 렌더 분기에 사용한다.
 */
export const isVideoPhoto = (p: Pick<SitePhoto, 'mime_type'>): boolean =>
  (p.mime_type ?? '').toLowerCase().startsWith('video/');

export interface UpdateSitePhotoRequest {
  category?: string;
  taken_at?: string;
  note?: string;
  related_incident_id?: number | null;
  related_visit_log_id?: number | null;
}

export interface UploadPhotoArgs {
  file: File;
  category: string;
  note?: string;
  takenAt?: string;     // ISO 8601
  uploadedBy?: string;
  relatedIncidentId?: number;
  relatedVisitLogId?: number;
}
